module.exports = __webpack_public_path__ + "static/media/CalendarEvent7.a5cb7351.jpg";